export interface DashboardInvalidation {
  revision?: unknown;
}

// Socket.IO/Redis Streams are at-least-once. A repeated revision must not fan
// out into another batch of identical HTTP reads, while different billable
// occurrences remain distinct revisions and are allowed to coalesce only in
// the short UI debounce window.
export class DashboardRefreshDeduper {
  private readonly seen = new Set<string>();
  private readonly order: string[] = [];

  constructor(private readonly capacity = 256) {}

  shouldRefresh(payload?: DashboardInvalidation): boolean {
    const revision = typeof payload?.revision === "string" ? payload.revision.trim() : "";
    if (!revision) return true;
    if (this.seen.has(revision)) return false;
    this.seen.add(revision);
    this.order.push(revision);
    while (this.order.length > this.capacity) {
      const evicted = this.order.shift();
      if (evicted) this.seen.delete(evicted);
    }
    return true;
  }
}
